import React from 'react'
import { Text, StyleSheet, TouchableOpacity } from 'react-native'
import { colors } from '../../../components/DesignSystem'
import Colors from '../../../constants/Colors'
import { useOrganizationStyles } from '../../../hooks/useOrganizationStyles'
export const AddMoreItemsButton = ({ navigation, inBanner = false }) => {
	const { buttonAlternateColor } = useOrganizationStyles()

	return (
		<TouchableOpacity
			style={[
				inBanner ? styles.inBannerTagContainer : styles.tagContainer,
				{
					backgroundColor: inBanner ? global.orgColor2 : colors.grayTranslucent,
				},
			]}
			onPress={() => {
				navigation.navigate('HomeStack', { screen: 'RestaurantSelect' })
			}}
		>
			<Text
				style={[
					inBanner ? styles.inBannerTagText : styles.tagText,
					{
						color: inBanner ? 'white' : Colors.greyscale[10],
					},
				]}
			>
				{'+ Add more items'}
			</Text>
		</TouchableOpacity>
	)
}

const styles = StyleSheet.create({
	tagContainer: {
		paddingHorizontal: 25,
		paddingVertical: 15,
		borderRadius: 30,
		alignSelf: 'flex-start',
		cursor: 'pointer',
	},
	tagText: {
		fontSize: 16,
		fontWeight: '500',
		textAlignVertical: 'center',
	},
	inBannerTagContainer: {
		paddingHorizontal: 15,
		paddingVertical: 2,
		borderRadius: 20,
		alignSelf: 'flex-start',
		cursor: 'pointer',
	},
	inBannerTagText: {
		fontSize: 14,
		fontWeight: '600',
		textAlignVertical: 'center',
	},
})
